import React from "react";
import "./main.scss";

const About = (props) => {
    return (
        <div className="component" >
            <div className="wordContainer">

                <div className = "subtitle">
                    Custom cakes and small-batch baking in NW DC
                </div>
            </div>
        </div>
    )
}
export default About;